/* eslint-disable indent, object-curly-newline, comma-dangle, semi */
import {
  page,
  // Buyer Landing Hero.
  shopPrivateSellerClick,
  psxSellMyCarClick,
  viewMyDashboardClick,
  // Shopping Steps
  psxVideoStart,
  psxVideoComplete,
  buyOnlineClick,
  psxVDPVehicleServiceContractsClick,
  psxVDPFinanceClick,
  psxVDPGapInsuranceClick,
  // Car Types
  atPSXStyleCategoryCTAClick,
  // Popular Vehicles
  shopAllPrivateSellerCarsClick,
  inventoryClick,
  inventoryImpressions,
  // FAQS
  psxLearnMoreFaqsClick,
  psxLearnMoreBuyersGuideClick,
  psxLearnMoreSellersGuideClick,
  psxStripeClick,
  // Header
  headerGeneralEventHandler,
} from 'reaxl-analytics';

import { kbbBaseUrl } from '@/constants/config';
import { getBrowserZipcode } from '@/utilities/akamaiFunctions';

const baseKbbData = {
  wspCode: 'KBB',
  dealerCode: 'kbbcox',
  fullUrl: `${kbbBaseUrl}|/marketplace`,
  zipCode: getBrowserZipcode(),
  pageId: 'syc_psx_buy',
};

export default {
  page: (metadata: any, option: any) => {
    const { data = {} } = metadata;
    return page({
      ...metadata,
      data: {
        ...baseKbbData,
        ...data,
        friendlyPageName: 'PSX Buyer Landing Page',
        pageType: 'own',
        pageEvents: [],
      },
      state: {
        user: {
          location: {
            zip: getBrowserZipcode(),
          },
        },
      },
    }, option);
  },
  // Buyer Landing Hero
  shopPrivateSellerClick: (metadata: any, option: any) => {
    const { data } = metadata;
    return shopPrivateSellerClick({
      ...metadata,
      data: {
        ...baseKbbData,
        ...data,
      },
    }, option);
  },
  sellMyCarClick: (metadata: any, option: any) => {
    const { data } = metadata;
    return psxSellMyCarClick({
      ...metadata,
      data: {
        ...baseKbbData,
        ...data,
      },
    }, option);
  },
  viewMyDashboardClick: (metadata: any, option: any) => {
    const { data } = metadata;
    return viewMyDashboardClick({
      ...metadata,
      data: {
        ...baseKbbData,
        ...data,
      },
    }, option);
  },
  psxVideoStart: (metadata: any, option: any) => {
    const { data } = metadata;
    return psxVideoStart({
      ...metadata,
      data: {
        ...baseKbbData,
        ...data,
      },
    }, {
      ...option,
      isPsxBlp: true,
    });
  },
  psxVideoComplete: (metadata: any, option: any) => {
    const { data } = metadata;
    return psxVideoComplete({
      ...metadata,
      data: {
        ...baseKbbData,
        ...data,
      },
    }, {
      ...option,
      isPsxBlp: true,
    });
  },
  // Shopping Steps
  buyOnlineClick: (metadata: any, option: any) => buyOnlineClick({
    ...metadata,
  }, option),
  psxVDPFinanceClick: (metadata: any, option: any) => {
    const { data = {} } = metadata;
    return psxVDPFinanceClick({
    ...metadata,
    data: {
        ...baseKbbData,
        ...data,
        pageId: 'syc_psx_buy'
      },
    }, option)
  },
  psxVDPVehicleServiceContractsClick: (metadata: any, option: any) => {
    const { data = {} } = metadata;
    return psxVDPVehicleServiceContractsClick({
    ...metadata,
    data: {
        ...baseKbbData,
        ...data,
        pageId: 'syc_psx_buy'
      },
    }, option)
  },
  psxVDPGapInsuranceClick: (metadata: any, option: any) => {
    const { data = {} } = metadata;
    return psxVDPGapInsuranceClick({
    ...metadata,
    data: {
        ...baseKbbData,
        ...data,
        pageId: 'syc_psx_buy'
      },
    }, option)
  },
  // Car Types
  atPSXStyleCategoryCTAClick: (metadata: any, option: any) => {
    const { data } = metadata;
    return atPSXStyleCategoryCTAClick({
      ...metadata,
      data: {
        ...baseKbbData,
        ...data,
      },
    }, option);
  },
  // Popular Vehicles
  kbbShopAllPrivateSellerCarsClick: (metadata: any, option: any) => {
    const { data = {} } = metadata;
    return shopAllPrivateSellerCarsClick({
    ...metadata,
    data: {
        ...baseKbbData,
        ...data,
      },
    }, option)
  },
  inventoryClick: (metadata: any, option: any) => {
    const { data = {} } = metadata;
    return inventoryClick({
      ...metadata,
      data: {
        ...baseKbbData,
        ...data?.data
      },
      state: data?.state,
      dataLayer: data?.dataLayer,
    }, option);
  },
  psxLearnMoreFaqsClick: (metadata: any, option: any) => {
    const { data } = metadata;
    return psxLearnMoreFaqsClick({
      ...metadata,
      data: {
        ...data,
        ...baseKbbData,
      },
    }, option);
  },
  psxLearnMoreBuyersGuideClick: (metadata: any, option: any) => {
    const { data } = metadata;
    return psxLearnMoreBuyersGuideClick({
      ...metadata,
      data: {
        ...data,
        ...baseKbbData,
      },
    }, option);
  },
  psxLearnMoreSellersGuideClick: (metadata: any, option: any) => {
    const { data } = metadata;
    return psxLearnMoreSellersGuideClick({
      ...metadata,
      data: {
        ...data,
        ...baseKbbData,
      },
    }, option);
  },
  psxStripeClick: (metadata: any, option: any) => {
    const { data } = metadata;
    return psxStripeClick({
      ...metadata,
      data: {
        ...data,
        ...baseKbbData,
      },
    }, option);
  },
  inventoryImpressions: (metadata: any, option: any) => inventoryImpressions({
    ...metadata,
    data: {
      ...baseKbbData,
      ...metadata?.data,
    },
    dataLayer: metadata?.dataLayer,
  }, option),
  headerGeneralEventHandler: (metadata: any, option: any) => headerGeneralEventHandler({
    ...metadata,
  }, option),
};
